
import logoSrc from './media/logo.png';
import html2pdf from 'html2pdf.js';

const LETTER_HEAD = `
   <div class="grid grid-cols-[1fr,auto] gap-2 pb-6 border-b border-gray-300">
      <div class="flex items-center">
         <img src="${logoSrc}" alt="Logo" class="w-[200px]" />
      </div>
      <div class="flex flex-col items-end justify-center text-gray-600">
         <div class="text-lg font-bold">Sun Plugged Energy</div>
         <div class="text-sm">info@sunpluggedenergy.com</div>
         <div class="text-sm">+263 861 226 3263</div>
         <div class="text-sm">www.sunpluggedenergy.com</div>
         <div class="text-sm">Suite C2, 187 Baines Avenue, Harare</div>
      </div>
   </div>
`

const TABLE_CLASS = "w-full [&_td]:pb-4 [&_th]:pb-4 [&_td]:px-4 [&_th]:px-4 [&_td]:text-sm [&_th]:text-sm [&_td]:text-gray-600";

class PDF {

   __html = LETTER_HEAD;

   /**
    * @param {string} html
    */
   addHTML(html) {
      this.__html += html;
   }

   addSpace(times = 1) {
      this.addHTML('<div class="h-4"></div>'.repeat(times));
   }

   __addTableTitle(title) {

      if (typeof title === 'undefined')
         return;

      this.addHTML(`
         <div class="text-xl font-bold text-gray-600 mb-4">${title}</div>
      `);
   }

   /**
    * 
    * @param {object} data
    * @param {string} data.title
    * @param {Array<string>} data.headers
    * @param {Array<Array<string>>} data.rows
    */
   addTable(data) {

      this.__addTableTitle(data.title);

      let tBody = '';
      if (data.rows.length > 0) {
         tBody = data.rows.map((row, index) => `
            <tr class="${index % 2 === 0 ? 'bg-gray-100' : ''}">
               ${row.map(cell => `<td>${typeof cell === 'undefined' ? '' : cell}</td>`).join('')}
            </tr>
         `).join('');
      } else {
         tBody = `
            <tr>
               <td colspan="${data.headers.length}" class="p-2">(empty list)</td>
            </tr>
         `;
      }

      this.addHTML(`
         <table class="${TABLE_CLASS}">
            <thead class="bg-orange-400 text-white">
               <tr>
                  ${data.headers.map(header => `<th class="text-left">${header}</th>`).join('')}
               </tr>
            </thead>
            <tbody>
               ${tBody}
            </tbody>
         </table>
      `);
   }

   /**
    * 
    * @param {object} opts
    * @param {string} opts.title
    * @param {object} opts.data 
    */
   addHorizontalTable(opts) {

      this.__addTableTitle(opts.title);

      this.addHTML(`
         <table class="${TABLE_CLASS}">
            <tbody>
               ${
                  Object.entries(opts.data).map(([key, value], index) => `
                     <tr class="${index % 2 === 0 ? 'bg-gray-100' : ''}">
                        <td class="font-bold">${key}</td>
                        <td>${typeof value === 'undefined' ? '' : value}</td>
                     </tr>
                  `).join('')
               }
            </tbody>
         </table>
      `);
   }
   
   save() {
      const options = {
         margin: 0.5,
         filename: this._filename,
         image: { type: 'jpeg', quality: 1 },
         html2canvas: { scale: 2 },
         jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
         enableLinks: true,
         pagebreak: {
            avoid: 'tr'
         }
      };

      html2pdf()
         .from(this.__html)
         .set(options)
         .save();

      navigator.clipboard.writeText(this.__html); // TODO: remove this line
         
   }

   /**
    * @param {string} filename 
    */
   constructor(title, filename='') {
      this._filename = `${filename || title}.pdf`;
      this.__html = LETTER_HEAD;

      this.addSpace();

      this.addHTML(`
         <div class="text-2xl font-bold text-gray-600 mb-4">${title}</div>
      `);

      this.addSpace();
   }

}


export default PDF